<template>
  <div class="niche-comment__box">
    <div class="niche-comment__header">
      <div class="niche-comment__header_text">Комментарии</div>
      <div class="niche-comment__header_total">
        {{ comments.length }}
      </div>
    </div>
    <div class="niche-comment__input">
      <UiInput
        v-model.trim="commentText"
        placeholder="Написать комментарий"
        :disabled="!canEdit"
      />
      <UiButton :disabled="!canEdit" @click="sendComment()">
        Отправить
      </UiButton>
    </div>
    <div v-if="!loadingComments" class="niche-comment__comment-list">
      <div
        v-for="(comment, index) in comments"
        :key="`${comment.user.lastname}_${index}_${comment.createdAt}`"
        class="niche-comment__comment-item"
      >
        <div class="comment-item__header">
          <div
            class="comment-item__header_avatar"
            :style="{ backgroundImage: `url('${comment.user.avatar}')` }"
          />
          <div class="comment-item__header_name">
            {{ comment.user.name }} {{ comment.user.lastname }}
          </div>
          <div class="comment-item__header_date">
            {{ comment.createdAt | dateFilter('DD.MM.YYYY') }}
          </div>
        </div>
        <div class="comment-item__text">
          {{ comment.text }}
        </div>
      </div>
      <div
        v-if="comments.length === 0"
        class="niche-comment__comment-item_empty"
      >
        <p>Комментарии отсутствуют</p>
      </div>
    </div>
    <div v-else class="niche-comment__comment-list">
      <div class="niche-comment__comment-item_empty">
        <p>Загружаем комментарии...</p>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import dateFilter from '@/filters/date.filter';

const { mapState } = createNamespacedHelpers('ratingInvestments');

export default {
  name: 'CommentsPopover',
  filters: {
    dateFilter
  },
  props: {
    nicheId: { type: Number, default: 0 },
    canEdit: { type: Boolean, default: true }
  },
  data: () => ({
    commentText: ''
  }),
  computed: {
    ...mapState({
      comments: state => state.data.comments,
      loadingComments: state => state.meta.isLoadingComments
    })
  },
  methods: {
    sendComment() {
      this.$store.dispatch('ratingInvestments/postComment', {
        nicheId: this.nicheId,
        comment: this.commentText
      });
      this.commentText = '';
    }
  }
};
</script>
